import React from "react";
import appIcon from "../../../assets/food-is-app-icon.jpg";

function PolicyHeader() {
  return (
    <div className="pp-header">
      <div className="pp-header-inner">
        <div className="pp-app-icon">
          <img src={appIcon} alt="Food-Is Plus app icon" />
        </div>
        <h1 className="pp-app-name">Food-Is Plus</h1>
        <p className="pp-subtitle">Privacy Policy</p>
        <span className="badge">Last updated: July 3, 2026</span>
      </div>
    </div>
  );
}

export default PolicyHeader;
